"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextZipCodeWithoutHyphenInput = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var styled_1 = __importDefault(require("@emotion/styled"));
var models_1 = require("../../../models");
var styles_1 = require("../../../styles");
var ErrorMessage_1 = require("../ErrorMessage");
var Input_1 = require("../Input");
var PropertyInputWrapper_1 = require("../PropertyInputWrapper");
var AutoCompleteAddressButton_1 = require("./AutoCompleteAddressButton");
var smallAndUp = styles_1.BREAKPOINTS.smallAndUp, lessThanSmall = styles_1.BREAKPOINTS.lessThanSmall;
var Wrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media (", ") {\n    display: flex;\n  }\n"], ["\n  @media (", ") {\n    display: flex;\n  }\n"])), smallAndUp);
var StyledInput = styled_1.default(Input_1.Input)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 203px;\n"], ["\n  max-width: 203px;\n"])));
var StyledAutoCompleteButton = styled_1.default(AutoCompleteAddressButton_1.AutoCompleteAddressButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media (", ") {\n    margin-left: 8px;\n  }\n  @media (", ") {\n    margin-top: 8px;\n  }\n"], ["\n  @media (", ") {\n    margin-left: 8px;\n  }\n  @media (", ") {\n    margin-top: 8px;\n  }\n"])), smallAndUp, lessThanSmall);
var TextZipCodeWithoutHyphenInput = function (_a) {
    var propertyId = _a.propertyId, placeholder = _a.placeholder, onChange = _a.onChange, onBlur = _a.onBlur, zipCode = _a.zipCode, errorMessages = _a.errorMessages, disabled = _a.disabled, className = _a.className, displayAutoCompleteAddressButton = _a.displayAutoCompleteAddressButton, _b = _a.autoCompleteAddressButtonLabel, autoCompleteAddressButtonLabel = _b === void 0 ? '' : _b, onAutoCompleteAddressButtonClick = _a.onAutoCompleteAddressButtonClick, displayError = _a.displayError;
    var handleChange = function (e) {
        onChange(e.target.value);
    };
    var handleBlur = function (e) {
        if (onBlur) {
            onBlur(e.target.value);
        }
    };
    var handleButtonClick = function () {
        if (onAutoCompleteAddressButtonClick) {
            onAutoCompleteAddressButtonClick();
        }
    };
    return (jsx_runtime_1.jsx(PropertyInputWrapper_1.PropertyInputWrapper, __assign({ propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.text, inputFormatType: models_1.TEXT_PROPERTY_INPUT_TYPE.zipCodeWithoutHyphen, errorMessages: errorMessages, className: className, displayError: displayError }, { children: jsx_runtime_1.jsxs(Wrapper, { children: [jsx_runtime_1.jsx(StyledInput, { "data-cy-property-item": "", error: displayError, value: zipCode, type: "tel", maxLength: 7, placeholder: placeholder, onChange: handleChange, onBlur: handleBlur, disabled: disabled, autoComplete: "postal-code", name: "postal-code", id: propertyId, "aria-invalid": displayError, "aria-errormessage": ErrorMessage_1.getFieldErrorMessageId(propertyId) }, void 0), displayAutoCompleteAddressButton && (jsx_runtime_1.jsx(StyledAutoCompleteButton, { label: autoCompleteAddressButtonLabel, onClick: handleButtonClick, disabled: disabled }, void 0))] }, void 0) }), void 0));
};
exports.TextZipCodeWithoutHyphenInput = TextZipCodeWithoutHyphenInput;
var templateObject_1, templateObject_2, templateObject_3;
